import React from 'react';
import { cn } from './utils';
import './fields.css';

export function Badge({ className, tone = 'neutral', ...props }) {
  return <span className={cn('pegasus-badge', className)} data-tone={tone} {...props} />;
}
